<template>
  <div>
    <div class="contents">
      <div class="filter-box-2">
        <div>
          <select aria-label="" v-model="searchData.pagesize">
            <option value="10" selected>
              {{ $t("filter.common.sort_by_10") }}
            </option>
            <option value="50">{{ $t("filter.common.sort_by_50") }}</option>
            <option value="100">
              {{ $t("filter.common.sort_by_100") }}
            </option>
          </select>
        </div>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            :placeholder="
              $t('title.common.nickname') +
              ' or ' +
              $t('title.common.confirm_by')
            "
            v-model="searchData.searchname"
          />
          <button
            class="btn btn-primary btn-lg icon-search"
            type="submit"
            value=""
          ></button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table board">
          <thead>
            <tr>
              <th class="col-auto d-none d-lg-table-cell">No.</th>

              <th class="col-auto">{{ $t("title.common.nickname") }}</th>
              <th class="col-auto d-none d-md-table-cell">
                {{ $t("title.common.automation") }}
                {{ $t("title.common.handicap") }}
              </th>
              <th class="col-auto d-lg-table-cell">
                {{ $t("title.common.activation") }}
                {{ $t("title.common.handicap") }}
              </th>

              <th class="col-auto d-none d-lg-table-cell">
                {{ $t("title.common.date") }}
              </th>
              <th class="col-auto d-none d-lg-table-cell">
                {{ $t("title.common.confirm_by") }}
              </th>

              <th class="th-arrow"></th>
            </tr>
          </thead>
          <tbody v-if="total_cnt > 0">
            <template v-for="(item, index) in handiList">
              <tr :key="index">
                <td class="col-auto d-none d-lg-table-cell">
                  {{ item.no }}
                </td>
                <td
                  class="col-auto d-sm-table-cell more"
                  @click="searchData.searchname = item.nickname"
                >
                  {{ item.nickname }}
                </td>

                <td class="col-auto d-none d-md-table-cell">
                  {{ item.handicap_auto | toFixed }}
                </td>
                <td class="col-auto d-lg-table-cell">
                  {{ hc_au(item.handicap_index) }}
                </td>

                <td class="col-auto d-none d-lg-table-cell text-date">
                  {{ item.timezone_regdate }}
                </td>
                <td class="col-auto d-none d-lg-table-cell">
                  {{ item.writer }}
                </td>

                <td class="td-arrow end" @click="toggle_tr(index)">
                  <img
                    src="/img/arrow_none_collapsed.png"
                    :class="{ 'btn-toggle-arrow': view_hide === index }"
                  />
                </td>
              </tr>
              <tr
                class="col-auto d-lg-none d-md-tabel-cell"
                :class="{ show: view_hide === index }"
                :key="index + 'r'"
                v-if="view_hide === index"
              >
                <td colspan="7">
                  <div class="toggle-content">
                    <div class="row">
                      <div class="col-4">No.</div>
                      <div class="col-8">{{ item.no }}</div>
                    </div>

                    <div class="row d-md-none">
                      <div class="col-4">
                        {{ $t("title.common.automation") }}
                        {{ $t("title.common.handicap") }}
                      </div>
                      <div class="col-8">
                        {{ item.handicap_auto }}
                      </div>
                    </div>
                    <!-- <div class="row">
                      <div class="col-6">Activation HC</div>
                      <div class="col-6 text-end">
                        {{ item.handicap_index > 0 ? "+" : ""
                        }}{{ item.handicap_index }}
                      </div>
                    </div> -->
                    <div class="row">
                      <div class="col-4">{{ $t("title.common.date") }}</div>
                      <div class="col-8 text-date">
                        {{ item.timezone_regdate }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4">
                        {{ $t("title.common.confirm_by") }}
                      </div>
                      <div class="col-8">{{ item.writer }}</div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="10">{{ $t("text.common.no_data") }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text>
          <i class="material-icons">keyboard_double_arrow_left</i>
        </template>
        <template #prev-text>
          <i class="material-icons">navigate_before</i>
        </template>
        <template #next-text>
          <i class="material-icons">navigate_next</i>
        </template>
        <template #last-text>
          <i class="material-icons">keyboard_double_arrow_right</i>
        </template>
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
    </div>
  </div>
</template>

<script>
import ax from "@/api/member";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "HandiList",
  data() {
    return {
      handiList: [],

      searchData: {
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        pagesize:
          this.$route.query.pagesize ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pagesize) ||
          10,
      },

      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_handilist();
    },

    "searchData.pageno": function () {
      this.get_handilist();
    },
    "searchData.pagesize": function () {
      this.searchData.pageno = 1;
      this.get_handilist();
    },
  },

  methods: {
    get_handilist() {
      ax.get_handilist(this.searchData, (data) => {
        this.handiList = data.handilist;
        console.log(this.handiList);
        this.total_cnt = data.handilistcnt;

        this.page_total = Math.ceil(this.total_cnt / this.searchData.pagesize);
      });
    },

    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  mounted() {
    this.get_handilist();
  },
  mixins: [myMixin],
};
</script>
